<template>
  <div class="cta-button" @click="$emit('click', $event)">
    <slot />
  </div>
</template>

<script>
export default {
  name: "CtaButton",
};
</script>

<style lang="scss" scoped>
.cta-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(4px, 0.85vw, 12px) clamp(16px, 6vw, 24px);
  background: #F8BF1E;
  font-family: 'Inter', sans-serif;
  font-weight: 900;
  text-shadow: none;
  min-width: 130px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, .8);
  font-size: clamp(12px, 1.05vw, 22px);
  user-select: none;
  cursor: pointer;

  &:hover {
    filter: brightness(104%);
  }

  &:active {
    filter: brightness(97%);
  }

  @media screen and (min-width: 1024px) {
    border-radius: 8px;
    font-size: clamp(14px, 1.25vw, 21px);
    padding: clamp(6px, 0.65vw, 12px) clamp(16px, 6vw, 24px);
  }

  @media screen and (min-width: 1280px) {
    font-size: clamp(14px, 1.2vw, 22px);
    padding: clamp(6px, 0.75vw, 12px) clamp(20px, 7vw, 30px);
    max-height: 60px;
  }
}
</style>
